export interface SalaryTemplateResponse {
	csvBase64: string;
	filename: string;
}

const downloadSalaryTemplate = async (
	token: string,
	companyId: string
): Promise<SalaryTemplateResponse> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/users/salary-template/${companyId}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	if (!response.ok) {
		throw new Error('Failed to download salary template');
	}

	const json = await response.json();
	return json.data;
};

export default downloadSalaryTemplate;
